
import Pagination from 'react-bootstrap/Pagination';

import { useDispatch, useSelector } from 'react-redux';
import { deleteNotification, getNotificationBarData, markNotificationAsRead, notificationBarActions, READ_TYPE, setNotification, UNREAD_TYPE } from '@store/slices';
import { useEffect, useState } from 'react';
import { Spin, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faEnvelopeOpen, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { ModalConfirmation } from '@components';
import { get, set } from 'lodash';
import { ILoginState } from '@share/store/slices';
import { useParams, useHistory} from 'react-router-dom';
import { axiosInstanceB2B, Toaster } from '@share/utils';
import { Routes, Urls } from '@share/constants';
import './notification.scss';
import { FormattedMessage, useIntl } from 'react-intl';
    
function NotificationListComponent() {
  const dispatch = useDispatch();

  const notificationBarStore = useSelector((state: { notificationBarStore: any }) => state.notificationBarStore?.notifications);
  const { loading, count, readNotificationCount, unreadNotificationCount } = useSelector((state: { notificationBarStore: any }) => state.notificationBarStore);
  const { user, account } = useSelector((state: { loginStore: ILoginState }) => state.loginStore);
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [type, setType] = useState<string | null>('unread');
  const [notificationToDelete, setNotificationToDelete] = useState<number | null>(null);
  const [notificationToRead, setNotificationToRead] = useState<boolean>(false);
  const resultsPerPage = 10;
  const history = useHistory();
  const intl = useIntl();

  useEffect(() => {
    dispatch(setNotification(currentPage, resultsPerPage, user?.userId, type));
    if (unreadNotificationCount === 0) {
      handleSee(READ_TYPE);
    }
  }, [currentPage]);

  useEffect(() => {
    return () => {
      setCurrentPage(1);
      dispatch(setNotification(1, 10, user?.userId, type));
      if (id && notificationBarStore?.items?.length) {
        const unreadNotification = notificationBarStore.items.find(
          (item: any) => String(item.id) === id && item.status === 0
        );
        if (unreadNotification) {
          readNotification(unreadNotification.id);
          return; 
        }
      }
    };
  }, []);

  const readNotification = async (id: number) => {
    const payload = {
      id: id,
      status : 1
    }
    const response = await axiosInstanceB2B.put(`${Urls.ReadNotification}`, payload);
    if (response.status === 200) {
      dispatch(getNotificationBarData(user?.userId));
      dispatch(setNotification(currentPage, resultsPerPage, user?.userId, type));
    }
  }
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleDelete = () => {
    const notificationId = notificationToDelete === -1 ? '-1' : get(notificationBarStore?.items, `[${notificationToDelete}].id`);
    if (notificationId) {
      dispatch(deleteNotification(notificationId, 1, 10, user?.userId, type, () => setNotificationToDelete(null)));
    }
  }

  const handleSee = (selectedType: string | null) => {
    if (id && notificationBarStore?.items?.length) {
      const isHighlighted = notificationBarStore.items.some((item: any) => String(item.id) === id);
      if (isHighlighted) {
        history.replace(`/${account?.name}${Routes.NotificationList}`);
      }
    }
    setType(selectedType);
    setCurrentPage(1);
    dispatch(setNotification(1, 10, user?.userId, selectedType));
  }

  const handleNotificationMarkAsRead = () => {
    const onSuccess = () => {
      setNotificationToRead(false);
      Toaster.success(intl.formatMessage({ id: 'notifications.marked.as.read' }));
      handleSee(READ_TYPE);
    };
    const onError = (error: any) => {
      console.error(intl.formatMessage({ id: 'notifications.marked.as.read.error' }), error);
      Toaster.error(`${intl.formatMessage({ id: 'something.went.wrong' })}: ${error}`);
    };
    if (!user?.userId) {
      console.warn(intl.formatMessage({ id: 'user.id.not.found' }));
      return;
    }
    dispatch(markNotificationAsRead(1, user.userId, onSuccess, onError));
  };
  

  return (
    <section className="pt-3 notificationPage">
      <h1 className="notificationPage_title">{intl.formatMessage({ id: 'notifications' })}</h1>

      {/* {!!notificationBarStore?.items?.length && ( */}
        <div className="notificationPage__actions">
          <span onClick={() => setNotificationToDelete(-1)} style={{ marginRight: '12px', fontSize: '15px', paddingTop: '7px', textDecoration: 'underline' }}><FormattedMessage id="clear.all" /></span>
          {unreadNotificationCount === 0 ? (
            <Tooltip title="No unread notifications">
              <span
                style={{
                  marginRight: '12px',
                  fontSize: '15px',
                  paddingTop: '7px',
                  color: 'gray',
                  cursor: 'not-allowed',
                }}
              >
                <FormattedMessage id="mark.all.as.read" />
              </span>
            </Tooltip>
          ) : (
            <span
              onClick={() => setNotificationToRead(!notificationToRead)}
              style={{
                marginRight: '12px',
                fontSize: '15px',
                paddingTop: '7px',
                textDecoration: 'none',
                cursor: 'pointer',
              }}
            >
              <FormattedMessage id="mark.all.as.read" />
            </span>
          )}
          {!!type && 
            <span onClick={() => handleSee(null)} style={{ marginRight: '12px', color: 'red', fontSize: '15px', paddingTop: '7px', textDecoration: 'underline' }}><FormattedMessage id="see.all" /></span>}

          <span onClick={() => handleSee(READ_TYPE)}><Tooltip title="See Read"><FontAwesomeIcon icon={faEnvelopeOpen} style={{ marginRight: '12px' }} /></Tooltip></span>
          <span onClick={() => handleSee(UNREAD_TYPE)}><Tooltip title="See Unread"><FontAwesomeIcon icon={faEnvelope} /></Tooltip></span>
        </div>
        {/* )} */}

      {loading ? (
        <div className="loading-widget-container text-center d-flex align-items-center justify-content-center">
          <Spin spinning={loading}></Spin>
        </div>
      ) : (
        !!notificationBarStore?.items?.length &&
          <div className="notificationPage_list">
            {notificationBarStore?.items?.map((item: any, index: number) => {
                const isHighlighted = String(item.id) === id;
                if (isHighlighted) {
                  dispatch(notificationBarActions.setCount(1));
                }

                return (
                  <div key={index}
                    className={`notificationPage_item ${isHighlighted ? 'highlighted-notification' : ''}`}
                  >
                    {item?.status === 0 && <span className="notif-badge left-position animation-blink"></span>}

                    <h2 className="notificationPage_item_heading">{item?.title}</h2>
                    <p className="mb-0 notificationPage_item_dec">{item?.description}</p>

                    <div className="notificationPage_item__buttons">
                      <span className="delete-action" onClick={() => setNotificationToDelete(index)}>
                        <Tooltip title="Delete" placement="top">
                          <FontAwesomeIcon icon={faTimesCircle} />
                        </Tooltip>
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
      )}

      {notificationBarStore?.items?.length === 0 && !loading && <p style={{ marginBottom: '0px', fontSize: '18px' }}>No notifications</p>}

      {notificationBarStore?.items && notificationBarStore.items.length > 0 && (
        <Pagination className="justify-content-end mt-5">
          <Pagination.First onClick={() => handlePageChange(1)} />
          <Pagination.Prev onClick={() => handlePageChange(Math.max(1, currentPage - 1))} />

          {currentPage > 3 && (
            <>
              <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
              {currentPage > 4 && <Pagination.Ellipsis />}
            </>
          )}

          {[...Array(notificationBarStore?.totalPages || 1)]
            .slice(
              Math.max(0, currentPage - 3),
              Math.min(currentPage + 2, notificationBarStore?.totalPages),
            )
            .map((_, index) => {
              const pageNumber = index + Math.max(1, currentPage - 2);
              return (
                <Pagination.Item
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              );
            })}

          {currentPage < (notificationBarStore?.totalPages || 1) - 2 && (
            <>
              {currentPage < (notificationBarStore?.totalPages || 1) - 3 && <Pagination.Ellipsis />}
              <Pagination.Item
                onClick={() => handlePageChange(notificationBarStore?.totalPages || 1)}
              >
                {notificationBarStore?.totalPages}
              </Pagination.Item>
            </>
          )}

          <Pagination.Next
            onClick={() =>
              handlePageChange(Math.min(notificationBarStore?.totalPages || 1, currentPage + 1))
            }
          />
          <Pagination.Last
            onClick={() => handlePageChange(notificationBarStore?.totalPages || 1)}
          />
        </Pagination>
      )}

      <ModalConfirmation
        message={notificationToDelete === -1 ? 'confirm.delete.all.notification' : 'confirm.delete.notification'}
        title="delete"
        yesMessage="yes"
        noMessage="no"
        visible={notificationToDelete != null}
        onCancel={() => setNotificationToDelete(null)}
        onConfirm={handleDelete}
      />
      <ModalConfirmation
        message={'confirm.mark.as.read.all.notification'}
        title="Read"
        yesMessage="yes"
        noMessage="no"
        visible={notificationToRead}
        onCancel={() => setNotificationToRead(false)}
        onConfirm={handleNotificationMarkAsRead}
      />
      
    </section>
  );
}

const NotificationList = NotificationListComponent;
export default NotificationList;
